import { useMemo } from 'react';

export const Region = {
  CA: 'Canada',
  UK: 'UK'
};

export const useRegion = () => {
  return useMemo(() => {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const parts = hostname.split('.');
    const suffix = parts.length > 0 ? parts[parts.length - 1] : '';

    return Region[suffix?.toUpperCase()] || Region[process.env.REACT_APP_REGION] || Region.CA;
  }, []);
};